import {canadianProvinces, counties, usStatesWithCodes} from 'core/constants/geo';

const statesMap = new Map<string, string>(
  usStatesWithCodes
    // mapping converts array of string[] to tuple [string, string]
    .map<[string, string]>(r => [r[0], r[1]])
);

export const getStateName = (stateCode: string) => {
  return statesMap.get(stateCode) || '';
};

// the 4-letter format matches ISO 3166-2:US but the BE requires
// the 2-letter code for some AWS reason
export const usStatesWithTwoLetterCodes = usStatesWithCodes.map(([code, name]) => [code.substring(3), name]);

export const usStatesWithTwoLetterCodesMap = {
  ...usStatesWithTwoLetterCodes.reduce((acc, [code, name]) => {
    acc[code] = name;
    return acc;
  }, {} as Record<string, string>),
};

export const US_STATE_FIELD_OPTIONS = usStatesWithTwoLetterCodes.map(([id, title]) => ({
  label: title,
  id,
}));

export const locationTree = [
  {
    key: 'all',
    title: 'All States',
    children: usStatesWithTwoLetterCodes.map(([key, title]) => ({
      key,
      title,
    })),
  },
];

export const CN_PROVINCE_FIELD_OPTIONS = canadianProvinces.map(([id, title]) => ({
  label: title,
  id,
}));

export const countryCodeToStateOptionsMap = {
  CA: CN_PROVINCE_FIELD_OPTIONS,
  US: US_STATE_FIELD_OPTIONS,
  // Fallback for empty country code value
  ['']: US_STATE_FIELD_OPTIONS,
};

export const countiesByState = usStatesWithTwoLetterCodes.reduce(
  (acc: Record<string, Array<{id: string; label: string}>>, item) => {
    acc[item[0]] = counties.reduce((stateItems: Array<{id: string; label: string}>, county) => {
      if (county[0].substring(0, 2) === item[0]) {
        stateItems.push({label: county[1].substring(0, county[1].length - 4), id: county[0]});
      }

      return stateItems;
    }, []);

    return acc;
  },
  {}
);
